import {
  format,
  differenceInMilliseconds,
  formatDistance,
  formatISO,
  addMonths,
  subMonths,
  getDate,
  getHours,
  getMinutes,
  isSameDay,
} from 'date-fns';
import { th } from 'date-fns/locale';

export default {
  methods: {
    isSameDay(dateLeft, dateRight) {
      return isSameDay(new Date(dateLeft), new Date(dateRight));
    },
    formatISO(date) {
      return formatISO(new Date(date));
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const dateMonthString = format(newDate, 'dd MMM', { locale: th });
      return `${dateMonthString} ${year + 543}`;
    },
    formatDateTime(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const dateMonthString = format(newDate, 'dd MMM', { locale: th });
      const hourMinuteString = format(newDate, 'HH:mm', { locale: th });
      return `${dateMonthString} ${year + 543} ${hourMinuteString}`;
    },
    formatShortDate(date) {
      const newDate = new Date(date);
      const formatDate = format(newDate, 'dd/MM', { locale: th });
      const fullYear = newDate.getFullYear() + 543;
      const shortYear = fullYear.toString().substring(2, 4);
      return `${formatDate}/${shortYear}`;
    },
    formatTime(date) {
      return format(new Date(date), 'HH:mm');
    },
    formatTimeByTime(time) {
      return format(time, 'HH:mm');
    },
    getDay(indexOfDay) {
      switch (indexOfDay) {
        case 1:
          return 'จันทร์';
        case 2:
          return 'อังคาร';
        case 3:
          return 'พุธ';
        case 4:
          return 'พฤหัส';
        case 5:
          return 'ศุกร์';
        case 6:
          return 'เสาร์';
        case 7:
          return 'อาทิตย์';
        default:
          return 'จันทร์';
      }
    },
    formatMonth(selectDate) {
      return format(new Date(selectDate), 'yyyy/MM');
    },
    getDate(date) {
      return getDate(new Date(date));
    },
    getNextMonth(date) {
      return addMonths(new Date(date), 1);
    },
    getPrevMonth(date) {
      return subMonths(new Date(date), 1);
    },
    getHours(date) {
      return getHours(new Date(date));
    },
    getMinutes(date) {
      return getMinutes(new Date(date));
    },
    differenceInMilliseconds(dateLeft, dateRight) {
      return differenceInMilliseconds(dateLeft, dateRight);
    },
    formatDistance(startDate, currentDate) {
      return formatDistance(new Date(startDate), new Date(currentDate));
    },
    transformTime(seconds) {
      let formattedSecond = '';
      // return seconds;
      switch (true) {
        case seconds < 60:
          formattedSecond = seconds;
          break;
        case seconds > 60 && seconds < 3600:
          formattedSecond = `${Math.floor(seconds / 60)} M.`;
          break;
        default:
          formattedSecond = '0 Second';
          break;
      }
      return formattedSecond;
    },
  },
};
